import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar.jsx"
import { STRIPE_PUBLISH_KEY } from "./utils/constants.js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import '@fontsource/yeseva-one';
import LandingPage from "./screens/LandingPage.jsx";

function App() {
  // const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);
  const options = {
    mode: "payment",
    amount: 1099,
    currency: "usd",
  };
  const Layout = () => {
    return <div>
      <Navbar />
      <LandingPage />
    </div>
  }
  return (
    <>
      {/* <Elements stripe={stripePromise} options={options}> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />} />
        </Routes>
        {/* <div>
            <Footer />
          </div> */}
      </BrowserRouter>
      {/* </Elements> */}
    </>
  );
}

export default App;
